/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 3/3/2021
 * @Example
 */

import React, {useEffect, useState, useMemo} from 'react';
import Config from '../../../../config';
import GridContainer from "../../../grid-container/grid-container";
import { Column } from "devextreme-react/data-grid";
import { MForm } from "../../../common/form-material";
import * as W09F2001Actions from '../../../../redux/W0X/W09F2001/W09F2001_actions';
import * as generalActions from "../../../../redux/general/general_actions";
import {connect} from 'react-redux';
import {bindActionCreators, compose} from "redux";
import {Dropdown, Label, Button} from "diginet-core-ui/components";
import { makeStyles } from "diginet-core-ui/theme";

const useStyles = makeStyles((theme) => ({
    wrapperDopdown: {
        justifyContent: 'flex-end',
        paddingBottom: theme.spacing(5),
        [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            justifyContent: "flex-start",
        }
    },
    dropdown: {
        width: 300,
        [theme.breakpoints.down("lg")]: {
            width: 200,
        }
    },
}));

const dataGridFilter = {
    limit: 10,
    skip: 0
};

const cbReportFilter = {
    limit: 10,
    slip: 0
};

const W09F2001 = (props) => {
    const {EmployeeID} = props;
    const classes = useStyles();

    const [state, setData] = useState({ TranTypeID: '', ReportID: '' });
    const [dataGrid, setDataGrid] = useState({ data: [], total: 0});
    const [cbReport, setCbReport] = useState({ data: { rows: [], total: 0 }});
    const [cbTrans, setCbTrans] = useState([]);
    const [error, setError] = useState({});

    const { TranTypeID, ReportID } = state;
    let [selectedRowKey, setSelectedRowKey] = useState([]);

    const report = useMemo(()=>{
        return cbReport.data.rows.find(i=>i.ReportID === state.ReportID);
        /* eslint-disable */
    },[state.ReportID, cbReport.data.rows]);

    const setState = (obj) => {
        return setData({ ...state, ...obj });
    };


    useEffect(() => {
        dataGridFilter.skip=0;
        cbReportFilter.skip=0;
        getCbReport();
        loadGrid();
        /* eslint-disable */
    }, [state.TranTypeID]);

    useEffect(() => {
        dataGridFilter.skip=0;
        cbReportFilter.skip=0;
        loadGrid();
        /* eslint-disable */
    }, [state.ReportID]);

    useEffect(() => {
        getCbTran();
        loadGrid();
        /* eslint-disable */
    }, []);

    const getCbReport = (isLoadmore = false) => {
        const params = {
            limit: cbReportFilter.limit,
            skip: cbReportFilter.skip,
            TranTypeID: state.TranTypeID
        };
        props.W09F2001Actions.getCbReport(params, (errors, data) => {
            if (errors) {
                Config.popup.show('ERROR', errors);
                return false;
            }
            const rows = data && data.rows ? data.rows : data;
            const total = data && data.total ? data.total : data.length;
            setCbReport({
                ...cbReport,
                data: {
                    rows: !isLoadmore ? rows : cbReport.data.rows.concat(rows),
                    total: total,
                },
            });
        })

    };

    const getCbTran = () => {
        props.W09F2001Actions.getCbTran({ Language: Config.language || 84 }, (errors, data) => {
            if (errors) {
                Config.popup.show('ERROR', errors);
                return false;
            }
            setCbTrans(data)
        })

    };

    const loadGrid = () => {
        const { mode } = props;
        const params = {
            FormID: 'W09F2050',
            Language: Config.language || 84,
            EmployeeID: EmployeeID,
            Mode: mode,
            Type: '',
            skip: dataGridFilter.skip,
            limit: dataGridFilter.limit,
            TranTypeID: TranTypeID,
            ReportTypeID: report?.ReportTypeID || ""
        };
        props.W09F2001Actions.getDataGridHR(params, (errors, data) => {
            if (errors) {
                Config.popup.show('ERROR', errors);
                return false;
            }
            setSelectedRowKey(data.rows.filter(i=>i.IsUsed));
            setDataGrid({ ...dataGrid, data: data.rows, total: data.total });
        })

    };

    const onChangePage = (page) => {
        dataGridFilter.skip = page * dataGridFilter.limit;
        loadGrid();
    };

    const onChangePerPage = (perPage) => {
        dataGridFilter.skip = 0;
        dataGridFilter.limit = perPage;
        loadGrid();
    };

    const onExport = () => {
        const validateRules = [
            {
                name: "TranTypeID",
                rules: "isRequired",
                value: state.TranTypeID,
            },
            {
                name: "ReportID",
                rules: "isRequired",
                value: state.ReportID
            }
        ];
        const valid = MForm.formValidation(validateRules);
        if (Object.keys(valid).length > 0) {
            setStateErrorText(valid);
            return false;
        }

        const params = {
            ReportTypeID: report.ReportTypeID,
            ReportID: report.ReportID,
            TitleU: report.TitleU,
            Remark:report.Remark,
            URL:report.URL,
            FileExt:report.FileExt,
            ExportType:report.FileExt,
            data:JSON.stringify(selectedRowKey)
        };

        props.generalActions.exportMulti(params, (err, data)=>{
            if (err) {
                Config.popup.show("ERROR", err);
                return false;
            }
            else if (data) {
                let el = document.getElementById("linkExportExcel_1");
                el.href = data.URL ? data.URL : "";
                el.download = data.fileName ? data.fileName : "";
                el.click();
            }
        })

    };

    const setStateErrorText = (objValue, key) => {
        setError({
            ...(error ? error : {}),
            ...objValue
        });
        return Object.keys(objValue).length !== 0;
    };

    return (
        <div>
            <div className={`display_row align-right ${classes.wrapperDopdown}`}>
                <div className={"mgr2x"}>
                    <Label>{!TranTypeID ?
                        <>
                            {Config.lang('Nghiep_vu')}
                            <span style={{color: Config?.coreTheme?.colors?.danger}}>*</span>
                        </>
                    : ""}</Label>
                    <Dropdown
                        error={error && error['TranTypeID']}
                        dataSource={cbTrans}
                        required
                        displayExpr={"TranTypeName"}
                        valueExpr={"TranTypeID"}
                        name="TranTypeID"
                        clearAble
                        onChange={(e) => {
                            setState({ TranTypeID: e.value || "", ReportID: "" });
                            dataGridFilter.skip=0;
                        }}
                        className={classes.dropdown}
                        viewType={"outlined"}
                        value={TranTypeID}
                    />
                </div>
                <div className={"mgr2x"}>
                    <Label>{!ReportID ?
                        <>
                            {Config.lang('Mau_bao_cao')}
                            <span style={{color: Config?.coreTheme?.colors?.danger}}>*</span>
                        </>
                        : ""}</Label>
                    <Dropdown
                        required
                        clearAble
                        error={error && error['ReportID']}
                        dataSource={cbReport?.data?.rows || []}
                        total={cbReport?.data?.total || 0}
                        skip={cbReportFilter.skip}
                        limit={cbReportFilter.limit}
                        displayExpr={"TitleU"}
                        valueExpr={"ReportID"}
                        name="ReportID"
                        value={ReportID}
                        viewType={"outlined"}
                        className={classes.dropdown}
                        onChange={(e) => {
                            setState({ ReportID: e.value ||"" });
                        }}
                        onLoadMore={(e) => {
                            cbReportFilter.skip = e.skip;
                            getCbReport(true);
                        }}
                    />
                </div>
                <Button
                    disabled={!state.ReportID || !state.TranTypeID || !selectedRowKey.length}
                    label={Config.lang("In")}
                    color={"primary"}
                    viewType={"filled"}
                    onClick={onExport}
                />
            </div>
            <GridContainer
                dataSource={dataGrid.data}
                selectedRowKey={selectedRowKey.map(i=>i.TransID)}
                keyExpr={"TransID"}
                gridProps={{
                    style: {
                        maxHeight: 400,
                        height: 200
                    }
                }}
                typePaging={"remote"}
                allowColumnResizing={true}
                showRowLines={false}
                pagerFullScreen={false}
                totalItems={dataGrid.total}
                itemPerPage={dataGridFilter.limit}
                skipPerPage={dataGridFilter.skip}
                listPerPage={[10, 20, 30]}
                selection={{
                    allowSelectAll: true,
                    mode: "multiple",
                    selectAllMode: "allPages",
                    showCheckBoxesMode: "always"
                }}
                onSelectionChanged={e=>{
                    setSelectedRowKey(e.selectedRowsData);
                }}
                onChangePage={onChangePage}
                onChangePerPage={onChangePerPage}
            >
                <Column
                    caption={Config.lang("Nghiep_vu")}
                    dataField={"TranTypeID"}
                    cellRender={e => {
                        const TranType = cbTrans.find(rs => rs.TranTypeID === e.data.TranTypeID);
                        return (
                            <div>{TranType?.TranTypeName}</div>
                        )
                    }}
                />
                <Column
                    caption={Config.lang("So_quyet_dinh")}
                    dataField={"DecisionNum"}
                />
                <Column
                    caption={Config.lang("Ngay_hieu_luc")}
                    dataType={"date"}
                    dataField={"ValidDate"}
                    format={"dd/MM/yyyy"}
                />
                <Column
                    caption={Config.lang("Ghi_chu")}
                    dataField={"Notice"}
                />
            </GridContainer>

            <a id="linkExportExcel_1" className="hide">File</a>
        </div>
    );

};

export default compose(
    connect(
        () => ({}),
        (dispatch) => ({
            generalActions: bindActionCreators(generalActions, dispatch),
            W09F2001Actions: bindActionCreators(W09F2001Actions, dispatch),
        }),
    )
)(W09F2001);
